import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Mic } from "lucide-react";

export function MobileCta({ to, label }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const on = () => setShow(window.scrollY > 520);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);
  return (
    <div className={`sm:hidden fixed inset-x-0 bottom-0 z-30 px-4 pt-3 bg-gradient-to-t from-[#0D0B09] via-[#0D0B09]/95 to-transparent transition-[opacity,transform] duration-300 ${show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-full pointer-events-none"}`}
      style={{ paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))" }} data-testid="landing-mobile-cta">
      <Link to={to} data-testid="landing-mobile-cta-button" className="btn-accent w-full justify-center py-3.5 text-base"><Mic size={17} /> {label}</Link>
    </div>
  );
}
